//
//
//
//

import cloneDeep from 'lodash/cloneDeep';
import _set from 'lodash/set';
import _get from 'lodash/get';
import ActionsEditor from '../actionsEditor.vue';
export default {
  name: 'TwinMapActionsEditor',
  components: {
    ActionsEditor: ActionsEditor
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    dashboardId: {
      type: String,
      required: true
    },
    customParameters: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    mapActions: {
      get: function get() {
        return _get(this.value, 'twinMapOptions.actions', []);
      },
      set: function set(value) {
        var clone = cloneDeep(this.value);
        _set(clone, 'twinMapOptions.actions', value);
        this.$emit('input', clone);
      }
    }
  }
};